const validateAnswer = function (errors, vm, showTip) {
  const { answerConfig: { requireInd, paramInt01 }, value, otherAnswer } = this
  if (requireInd === '1' && !value.length) {
    errors.push(vm.cvtLang('tipAnswerNull', vm.surveyInfoLang.tipAnswerNull))
    return !errors.length
  }
  return !errors.length
}

const validate = function (vm, showTip) {
  const errors = []
  return {
    result: validateAnswer.call(this, errors, vm, showTip),
    errors
  }
}

const answerValidate = {
  validateAnswer,
  validate
}

export default answerValidate



// WEBPACK FOOTER //
// ./src/components/editor/CascadeBox/answerValidate.js